import { Checkbox } from 'antd';
import styled from 'styled-components';

export const CheckboxStyled = styled(Checkbox)`
  & > span:nth-child(2) {
    width: 100%;
  }
`;
